import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ConcluirAgendamentoDTO } from "types/dto/ConcluirAgendamentoDTO";
import { ResponseDTO } from "types/dto/ResponseDTO";
import { RequestConcluirAgendamento } from "types/request/RequestConcluirAgendamento";

export const usePostConcluirAgendamentoContatos = () => {
  const onSuccess = (
    request: RequestConcluirAgendamento,
    resposne: ResponseDTO<ConcluirAgendamentoDTO>
  ) => {
    if (resposne.errorMessage) {
      toast.error(resposne.errorMessage);
    } else {
      queryClient.invalidateQueries(["agendamentos-contatos"]);
      queryClient.invalidateQueries(["informacoes-agendamento"]);
      toast.success("Conclusão do agendamento alterado com sucesso!");
    }
  };

  return usePost<RequestConcluirAgendamento>({
    url: api.agendamentoContato.postConcluirAgendamento,
    onSuccess,
  });
};
